import { render, staticRenderFns } from "./c3.vue?vue&type=template&id=097dbd50&scoped=true"
import script from "./c3.vue?vue&type=script&lang=js"
export * from "./c3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097dbd50",
  null
  
)

export default component.exports